import { createTheme } from '@mui/material/styles';

export const PORTAL_THEME_MODE_STORAGE_KEY = 'portal_theme_mode';

export const getStoredThemeMode = () => {
  try {
    const storedMode = localStorage.getItem(PORTAL_THEME_MODE_STORAGE_KEY);
    return storedMode === 'dark' ? 'dark' : 'light';
  } catch (error) {
    return 'light';
  }
};

export const createPortalTheme = (mode = getStoredThemeMode()) => {
  const isDark = mode === 'dark';

  return createTheme({
    palette: {
      mode,
      primary: {
        main: '#2A85E2',
      },
      secondary: {
        main: '#232FCB',
      },
      background: {
        default: isDark ? '#0b1020' : '#f6f7fb',
        paper: isDark ? '#11182d' : '#ffffff',
      },
      text: {
        primary: isDark ? '#eef3ff' : '#1f2937',
        secondary: isDark ? '#aeb8d4' : '#64748b',
      },
      divider: isDark ? 'rgba(174, 184, 212, 0.2)' : 'rgba(15, 23, 42, 0.12)',
    },
    typography: {
      fontFamily: 'Futura, Arial, sans-serif',
      h4: {
        fontWeight: 700,
      },
      h5: {
        fontWeight: 600,
      },
      button: {
        textTransform: 'none',
      },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            backgroundColor: isDark ? '#0b1020' : '#f6f7fb',
            color: isDark ? '#eef3ff' : '#1f2937',
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: 'none',
          },
        },
      },
    },
  });
};

const theme = createPortalTheme();

export default theme;
